var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('transition',{on:{"after-leave":_vm.doDestroy}},[_c('span',{ref:"popper",class:{show:!_vm.disabled && _vm.showPopper}},[(_vm.$slots.tip)?_c('div',{ref:"tooltip",staticClass:"tooltip",style:(`max-width: ${_vm.maxWidth}px`)},[_vm._t("tip")],2):_vm._e(),_vm._t("default")],2)]),_vm._t("reference")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }